import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';

export const PageStyles = styled(OnboardingPage)`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    pointer-events: none;
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding: 0 0 26px;
    }

    .onboarding-options-list {
      margin-top: 24px;
    }
  }
`;

export const TitleStyles = styled(OwnAiTitle)`
  margin-bottom: 0;
`;
